import { render, staticRenderFns } from "./changeSignature.vue?vue&type=template&id=4d373ca8&scoped=true&"
import script from "./changeSignature.vue?vue&type=script&lang=js&"
export * from "./changeSignature.vue?vue&type=script&lang=js&"
import style0 from "./changeSignature.vue?vue&type=style&index=0&id=4d373ca8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d373ca8",
  null
  
)

export default component.exports